import React from 'react';
import ContentSection from '../ContentSection';
import RadioGroup from '../RadioGroup';
import RadioButton from '../RadioButton';
import Moment from 'moment';
import SelectBox from '../SelectBox';
import type { OptionTuples} from '../../helpers/react-helpers';
import {linkChecked, linkState, selectOptions} from '../../helpers/react-helpers'
import {GridCol, GridRow} from '../grid-form';
import SaveSubmitButton from '../SaveSubmitButton';
import {pick} from 'lodash';
import CheckboxLabel from '../CheckboxLabel';
import icons from '../../../markons/markons';
import InputWithIcon from '../InputWithIcon';
import {postDownload, resolveRoute} from '../../helpers/ajax'
import ButtonRow from "../ButtonRow";
import AioDatePicker from "../aio-inputs/AioDatePicker";

const now = Moment();
const DATE_FORMAT = 'YYYY-MM-DD';

interface State {
    dateType: string
    whichDate: string
    month: string
    start: string
    end: string
    onlyCompanies: boolean
    occasionId: string|number
}

interface Props {
    occasions: OptionTuples
}

export default class CustomerRecordExport extends React.Component<Props, State> {

    state = {
        dateType: 'MONTH',
        whichDate: 'CREATE',
        month: now.format('YYYY-MM'),
        start: now.clone().subtract(1, 'month').format(DATE_FORMAT),
        end: now.format(DATE_FORMAT),
        onlyCompanies: false,
        occasionId: '',
    }

    submit = (ev: any) => {
        ev.preventDefault();

        const postData = pick(this.state, ['dateType', 'whichDate', 'onlyCompanies', 'occasionId'])

        switch (this.state.dateType) {
            case 'MONTH':
                Object.assign(postData, pick(this.state, ['month']))
                break;
            case 'DATE_RANGE':
                Object.assign(postData, pick(this.state, ['start', 'end']))
                break;
            default:
                throw new Error(`Invalid date type: ${this.state.dateType}`)
        }

        postDownload({
            url: resolveRoute('reports.downloadCustomerRecords'),
            data: postData,
            filename: `CustomerRecords.csv`
        })
    }


    render() {
        const monthIter = Moment()
        const months = [];
        const numMonths = 36;

        const startDateOptions: Partial<React.ComponentPropsWithoutRef<typeof AioDatePicker>> = {}
        const endDateOptions: Partial<React.ComponentPropsWithoutRef<typeof AioDatePicker>> = {}

        switch (this.state.whichDate) {
            case 'CREATE':
                startDateOptions.maxDate = Moment.min(now, Moment(this.state.end, DATE_FORMAT)).toDate();
                endDateOptions.minDate = Moment(this.state.start, DATE_FORMAT).toDate();
                endDateOptions.maxDate = now.toDate();
                break;
            case 'PICKUP':
                startDateOptions.maxDate = Moment(this.state.end, DATE_FORMAT).toDate();
                endDateOptions.minDate = Moment(this.state.start, DATE_FORMAT).toDate();
                monthIter.add(12, 'months');
                break;
        }

        for (let i = 0; i < numMonths; ++i) {
            months.push({
                label: monthIter.format('MMMM YYYY'),
                value: monthIter.format('YYYY-MM')
            });
            monthIter.subtract(1, 'month');
        }

        return (
            <ContentSection title="Export Customer Records" className="no-scroll">
                <p>Export customer records.</p>

                <form className="grid-form" onSubmit={this.submit}>
                    <GridRow>
                        <GridCol>
                            <label>Search by which date?</label>
                            <RadioGroup {...linkState.call(this, 'whichDate')}>
                                <RadioButton value="CREATE">Booking Created</RadioButton>
                                <RadioButton value="PICKUP">First Pickup</RadioButton>
                            </RadioGroup>
                        </GridCol>
                    </GridRow>

                    <GridRow>
                        <GridCol>
                            <label>What period?</label>
                            <RadioGroup {...linkState.call(this, 'dateType')}>
                                <RadioButton value="MONTH">Month</RadioButton>
                                <RadioButton value="DATE_RANGE">Date Range</RadioButton>
                            </RadioGroup>
                        </GridCol>
                    </GridRow>

                    {this.state.dateType === 'MONTH' && <GridRow><GridCol>
                        <SelectBox className="auto-width" {...linkState.call(this, 'month')}>
                            {months.map(mo => (
                                <option key={mo.value} value={mo.value}>{mo.label}</option>
                            ))}
                        </SelectBox>
                    </GridCol>
                    </GridRow>}

                    {this.state.dateType === 'DATE_RANGE' && <GridRow><GridCol>
                        <AioDatePicker label="Start Date" {...linkState.call(this, 'start', (date:string) => date)}
                                       {...startDateOptions} inline/> to <AioDatePicker label="End Date" {...linkState.call(this, 'end', (date:string)=>date)} {...endDateOptions} inline/>
                    </GridCol>
                    </GridRow>}

                    <GridRow>
                        <GridCol>
                            <label>Occasion Selection</label>
                            {/* @ts-expect-error ts-migrate(2322) FIXME: Property 'children' does not exist on type 'Intrin... Remove this comment to see the full error message */}
                            <InputWithIcon icon={icons.miscFirecracker} width="200px">
                                <SelectBox id="occasion_id" {...linkState.call(this, 'occasionId', undefined, '')}>
                                    <option value="">ALL</option>
                                    {selectOptions(this.props.occasions)}
                                </SelectBox>
                            </InputWithIcon>
                        </GridCol>
                    </GridRow>

                    <GridRow>
                        <GridCol>
                            <CheckboxLabel {...linkChecked.call(this, 'onlyCompanies')}>Only Companies</CheckboxLabel>
                        </GridCol>
                    </GridRow>

                    <ButtonRow>
                        <ButtonRow.Left>
                            <SaveSubmitButton>Download CSV</SaveSubmitButton>
                        </ButtonRow.Left>
                    </ButtonRow>
                </form>
            </ContentSection>
        )

    }
}
